/**
 * Use this type to reference a plain object with
 * random string keys.
 */
export interface Plain {
  // deno-lint-ignore no-explicit-any
  [key: string]: any
}

/**
 * Any JSON-serialisable type.
 */
export type JSONPrimitive = string | number | boolean | null
export type JSONArray = JSONValue[]
export interface JSONObject {
  [key: string]: JSONValue
}
export type JSONValue = JSONPrimitive | JSONObject | JSONArray

/**
 * Clones a JSONValue as defined above, if necessary.
 */
export function cloneJSONValue<T extends JSONValue>(value: T): T {
  if (value === null) return value
  if (Array.isArray(value)) {
    return value.map(cloneJSONValue) as T
  }
  if (typeof value === 'object') {
    const out: Record<string, JSONValue> = {}
    for (const [k, v] of Object.entries(value)) {
      out[k] = cloneJSONValue(v)
    }
    return out as T
  }
  return value
}

/**
 * Type predicates to be used in type-narrowing assertions, e.g.
 *
 *   assert(notNull(someValue))
 *   ... now the type of someValue does not include null ...
 *
 * or
 *  if (isOk(returnValue)) {
 *     ...in this block we know returnValue.ok is present and of the correct type.
 *  }
 *
 * @param value the value to be tested.
 * @returns true if not null, otherwise false.
 */
export function notNull<T>(value: T | null): value is T {
  return value !== null
}

export function isDefined<T>(value: T | undefined): value is T {
  return value !== undefined
}
